import { RefObject, useEffect } from 'react';

export function useClickAway<E extends Event = MouseEvent>(
  ref: RefObject<HTMLElement | null>,
  onClickAway: (event: E) => void,
) {
  useEffect(() => {
    const handler = (event: Event) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        onClickAway(event as E);
      }
    };

    document.addEventListener('mousedown', handler);
    document.addEventListener('touchstart', handler);

    return () => {
      document.removeEventListener('mousedown', handler);
      document.removeEventListener('touchstart', handler);
    };
  }, [ref, onClickAway]);
}
